module.exports = __webpack_public_path__ + "static/media/devis-habitation.bbc9d4e0.webp";